'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Select = require('@cimpress/react-components/lib/Select');

var _Select2 = _interopRequireDefault(_Select);

var _languages = require('../constants/languages');

var _languages2 = require('../utils/languages');

var _locales = require('../constants/locales');

var _locales2 = _interopRequireDefault(_locales);

var _timeZones = require('../constants/timeZones');

var _timeZones2 = _interopRequireDefault(_timeZones);

var _reactI18next = require('react-i18next');

var _i18n = require('../i18n');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var GlobalSettings = function (_Component) {
  _inherits(GlobalSettings, _Component);

  function GlobalSettings() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, GlobalSettings);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = GlobalSettings.__proto__ || Object.getPrototypeOf(GlobalSettings)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      languageOptions: (0, _languages.getLanguageOptions)(_this.props.supportedLanguages)
    }, _this.onLanguageSelected = function (language) {
      return _this.props.onLanguageUpdated(language);
    }, _this.onLocaleSelected = function (locale) {
      return _this.props.onLocaleUpdated(locale);
    }, _this.onTimeZoneSelected = function (timeZone) {
      return _this.props.onTimeZoneUpdated(timeZone);
    }, _this.tt = function (key) {
      var _this$props = _this.props,
          t = _this$props.t,
          lang = _this$props.lang;
      return t(key, {
        lng: lang
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(GlobalSettings, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          language = _props.language,
          locale = _props.locale,
          timeZone = _props.timeZone;
      return _react2.default.createElement(_react.Fragment, null, _react2.default.createElement(_Select2.default, {
        name: 'language',
        placeholder: this.tt('global_settings_language_placeholder'),
        options: this.state.languageOptions,
        simpleValue: true,
        value: (0, _languages2.getFirstSupportedLanguage)(language, this.props.supportedLanguages),
        onChange: this.onLanguageSelected,
        tether: true,
        helpText: this.tt('global_settings_language_help_text'),
        clearable: false
      }), _react2.default.createElement(_Select2.default, {
        style: {
          marginTop: '15px'
        },
        name: 'locale',
        placeholder: this.tt('global_settings_locale_placeholder'),
        options: _locales2.default,
        simpleValue: true,
        value: locale,
        onChange: this.onLocaleSelected,
        tether: true,
        helpText: this.tt('global_settings_locale_help_text'),
        clearable: false
      }), _react2.default.createElement(_Select2.default, {
        style: {
          marginTop: '15px'
        },
        name: 'timeZone',
        placeholder: this.tt('global_settings_timezone_placeholder'),
        options: _timeZones2.default,
        simpleValue: true,
        value: timeZone,
        onChange: this.onTimeZoneSelected,
        tether: true,
        helpText: this.tt('global_settings_timezone_help_text'),
        clearable: false
      }));
    }
  }]);

  return GlobalSettings;
}(_react.Component);

GlobalSettings.propTypes = {
  lang: _propTypes2.default.string,
  language: _propTypes2.default.string,
  locale: _propTypes2.default.string,
  timeZone: _propTypes2.default.string,
  onLanguageUpdated: _propTypes2.default.func.isRequired,
  onLocaleUpdated: _propTypes2.default.func.isRequired,
  onTimeZoneUpdated: _propTypes2.default.func.isRequired,
  supportedLanguages: _propTypes2.default.arrayOf(_propTypes2.default.oneOf(_languages.languageCodes)).isRequired
};
var GlobalSettingsWithTranslation = (0, _reactI18next.withTranslation)('react-platform-settings')(GlobalSettings);

exports.default = function (props) {
  return _react2.default.createElement(GlobalSettingsWithTranslation, _extends({
    i18n: (0, _i18n.getI18nInstance)()
  }, props));
};